import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import EntityResultsTabState from './EntityResultsTabState';
import EntityResultsView from './EntityResultsView';

export default class EntityResultsTabView extends BufferTabView<EntityResultsTabState> {
  override render(): this {
    const model = this.model.get('model');

    ReduxDOMRender.renderToDOM(<EntityResultsView entityId={model.id} />, this.el);
    return this;
  }

  override remove(): Backbone.View<EntityResultsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

EntityResultsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
